<template>
<div class="chapter">
<div class="inner_page">
<blockquote>
<p class="noind" id="start">Scientists at Columbia University’s Lamont-Doherty Earth Observatory have found that the Earth’s inner core is rotating faster than the planet itself. The Earth’s solid iron inner core . . . is surrounded by a much larger liquid outer core, and together the two form a giant electrical motor. . . . About a billion amps of current is flowing . . . across the boundary between the inner and outer cores. . . . ‘The really surprising thing is how fast the core is moving,’ said seismologist Paul Richards, who along with fellow seismologist Xiaodong Song made the discovery. . . . Over the past 100 years that extra speed has given the core a quarter turn on the planet as a whole. . . . [T]he motion is about 100,000 times faster than the drift of continents. . . . [Each] year, the inner core rotates about one longitudinal degree more than the Earth’s mantle and crust. . . . Pressure at the inner core surface is millions of times higher than the atmospheric pressure at Earth’s surface. . . . The mass of the inner core is about one hundred million million million tons—which is about 30 per cent greater than the mass of the moon.</p>
<p class="right" style="margin-top:20px;">—Excerpt from a Columbia University</p>
<p class="right">press release dated July 18, 1996.</p>
</blockquote>
<p class="noind" style="margin-top:30px;">The foregoing results were confirmed by subsequent research at Columbia University and the University of Illinois at Urbana-Champaign, as described in an article in the August 26, 2005, issue of <i>Science</i>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5start.vue?913f470a